var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGalleryLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5296 2.5H7.0037C4.51638 2.5 2.5 4.51638 2.5 7.0037V38.5296C2.5 41.017 4.51638 43.0333 7.0037 43.0333H38.5296C41.017 43.0333 43.0333 41.017 43.0333 38.5296V7.0037C43.0333 4.51638 41.017 2.5 38.5296 2.5Z",
    fill: "url(#paint0_linear_7240_25299)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2999 19.5668C17.6563 19.5668 19.5665 17.6565 19.5665 15.3001C19.5665 12.9437 17.6563 11.0334 15.2999 11.0334C12.9435 11.0334 11.0332 12.9437 11.0332 15.3001C11.0332 17.6565 12.9435 19.5668 15.2999 19.5668Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6607 18.5L7.83301 43.0333H38.7663C41.1228 43.0333 43.033 41.1231 43.033 38.7667V30.2091L31.6607 18.5Z",
    fill: "url(#paint1_linear_7240_25299)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1663 36.6333H30.2329C29.0547 36.6333 28.0996 37.5884 28.0996 38.7666V46.2333C28.0996 47.4115 29.0547 48.3666 30.2329 48.3666H45.1663C46.3445 48.3666 47.2996 47.4115 47.2996 46.2333V38.7666C47.2996 37.5884 46.3445 36.6333 45.1663 36.6333Z",
    fill: "url(#paint2_linear_7240_25299)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3662 36.6332V32.3665C32.3662 30.952 32.9281 29.5955 33.9283 28.5953C34.9285 27.5951 36.2851 27.0332 37.6995 27.0332C39.114 27.0332 40.4706 27.5951 41.4708 28.5953C42.471 29.5955 43.0329 30.952 43.0329 32.3665V36.6332",
    stroke: "white",
    strokeWidth: 2.13333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_25299",
    x1: 22.7667,
    y1: 2.5,
    x2: 22.7667,
    y2: 43.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BC7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_25299",
    x1: 25.433,
    y1: 18.5,
    x2: 25.433,
    y2: 43.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7FF88",
    stopOpacity: 0.32
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7240_25299",
    x1: 29.1663,
    y1: 36.6333,
    x2: 46.2329,
    y2: 51.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45FFE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGalleryLocked);
export default __webpack_public_path__ + "static/media/icon_gallery_locked.916465f7d4a048c952ec2cfe2bd3e9df.svg";
export { ForwardRef as ReactComponent };